import classNames from 'classnames';
import c from './display.module.scss';
import { Dropdown, fontStyles, TextField } from '@monash/portal-react';
import { Controller, useFormContext } from 'react-hook-form';
import {
  AppIcons,
  formatUrl,
  getIcon,
  isUrl,
} from '@monash/portal-frontend-common';
import { getLabelForAppIcon, sortAppIconOptions } from './utils';
import { INLINE_ERROR_MSGS } from '../../../../constants/inline-error-messages';
import InlineErrorMessage from '../../../common/inline-error-message/InlineErrorMessage';
import { LINKS_INLINE_ERROR_MSGS } from '../constants';

const Display = ({ disabled }) => {
  const {
    trigger,
    formState: { errors, isSubmitted },
  } = useFormContext();

  const iconOptions = Object.keys(AppIcons)
    .map((iconKey) => {
      return {
        text: getLabelForAppIcon(iconKey),
        value: iconKey,
        label: <div className={c.appIconContainer}>{getIcon(iconKey)}</div>,
      };
    })
    .sort(sortAppIconOptions);

  return (
    <div className={c.container}>
      <div className={c.section}>
        <div className={classNames(fontStyles.label, c.label)}>Title</div>
        <Controller
          name="name"
          rules={{ required: INLINE_ERROR_MSGS.TITLE }}
          render={({ field: { value, onChange, onBlur } }) => (
            <TextField
              placeholder="Title"
              value={value}
              onChange={onChange}
              onBlur={onBlur}
              multiline
              disabled={disabled}
              error={() => errors.name}
              errorMsg={errors.name?.message}
            />
          )}
        />
      </div>
      <div className={c.section}>
        <div className={classNames(fontStyles.label, c.label)}>Icon</div>
        <Controller
          name="icon"
          rules={{ required: LINKS_INLINE_ERROR_MSGS.ICON }}
          render={({ field: { value, onChange, onBlur } }) => (
            <Dropdown
              data={iconOptions}
              value={value}
              onBlur={onBlur}
              onChange={(e) => {
                onChange(e);
                isSubmitted && trigger('icon'); // Manually validate b/c dropdown's onBlur doesn't validate on first blur
              }}
              disabled={disabled}
            />
          )}
        />
        {errors.icon && <InlineErrorMessage message={errors.icon?.message} />}
      </div>
      <div className={c.section}>
        <div className={classNames(fontStyles.label, c.label)}>Description</div>
        <Controller
          name="description"
          rules={{ required: INLINE_ERROR_MSGS.DESCRIPTION }}
          render={({ field: { value, onChange, onBlur } }) => (
            <TextField
              placeholder="Description"
              multiline
              value={value}
              onChange={onChange}
              onBlur={onBlur}
              disabled={disabled}
              error={() => errors.description}
              errorMsg={errors.description?.message}
            />
          )}
        />
      </div>
      <div className={c.section}>
        <div className={classNames(fontStyles.label, c.label)}>Url</div>
        <Controller
          name="url"
          rules={{
            validate: (value) => {
              const formattedUrl = formatUrl(value);
              if (!isUrl(formattedUrl)) return LINKS_INLINE_ERROR_MSGS.URL;
            },
          }}
          render={({ field: { value, onChange, onBlur } }) => (
            <TextField
              placeholder="https://www.monash.edu"
              value={value}
              onChange={onChange}
              onBlur={onBlur}
              disabled={disabled}
            />
          )}
        />
        {errors.url && <InlineErrorMessage message={errors.url?.message} />}
      </div>
    </div>
  );
};

export default Display;
